export default "__VITE_ASSET__6U_DorNn__"